export default __webpack_public_path__ + "static/media/icon3.4d43bb66.png";